import React from 'react';
import { ImageWidget, VideoUrlWidget } from './widgets';
import SortableField from './SortableField';
import schemas from './schemas/curator';

const graphqlUrl = process.env.REACT_APP_GRAPHQL_URL;

const resources = Object.keys(schemas).map(key => schemas[key]);

// NOTE: columnNames is a computed property
const CuratorGqlCmsConfig = {
  brand: 'EncourageX CMS',
  title: 'EncourageX CMS',
  mainTitle: 'EncourageX CMS - Curator Dashboard View',
  modelsTitle: 'My Curated Content',
  templateTitle: 'Free Template Library - Customizable Content provided by EncourageX to Curators',
  graphqlUrl,
  jsonSchemaFormExtensions: {
    widgets: {
      imageWidget: ImageWidget,
      videoUrlWidget: VideoUrlWidget,
    },
    fields: {
      sortableField: SortableField,
    },
  },
  readManySchema: {
    cellFormatter(value) {
      if (value && typeof value === 'object') {
        return <pre>{JSON.stringify(value)}</pre>;
      }
      return value;
    },
    sortStrategy: {
      type: 'SINGLE',
      defaultSortField: 'title',
    },
    searchStrategy: {
      type: 'FULLTEXT',
    },
    paginationStrategy: {
      type: 'STATIC',
    },
  },
  resources,
};

export default CuratorGqlCmsConfig;



// WEBPACK FOOTER //
// ./src/CuratorGqlCmsConfig.js